import React, { useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import Header from './pages/Header.js';
import HeroSection from './pages/Jumbotron.js';
import './pages/Styles.css';
import Footer from './pages/Footer.js';
import Vision from './pages/Vision.js';
import Getintouch from './pages/Getintouch.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Companion from './pages/Companion.js';
import Testimonials from './pages/Testimonial.js';
import Faq from './pages/Faq.js';
import HowItWorks from './pages/HowItWorks.js';
import Gallery from './pages/Gallery.js';
import ReachUs from './pages/Reachus.js';
import Layout from './pages/Layout.js';
import AnalyticsSection from './pages/AnalyticsSection.js';
import NotFound from "./pages/NotFound";

function LandingPage() {
  const aboutRef = useRef(null);
  const getInTouchRef = useRef(null);
  const contactRef = useRef(null);
  const memoryRef = useRef(null);

  return (
    <>
      {/* SEO for HOME PAGE (/) */}
      <Helmet>
        <title>gupsy – Your AI Companion for Thoughtful Conversations</title>
        <meta
          name="description"
          content="gupsy is your AI-powered companion for meaningful conversations, emotional support, and self-reflection. Talk, vent, and reflect in a safe space."
        />
        <link rel="canonical" href="https://www.gupsy.neomonkstech.com/"/>
      </Helmet>

      <div>
        <Header sectionsRef={{ about: aboutRef, getInTouch: getInTouchRef }} />
        <HeroSection />
        <AnalyticsSection />
        <Vision ref={aboutRef} />
        <Companion />
        <Getintouch ref={getInTouchRef} />
        <HowItWorks ref={memoryRef} />
        <Testimonials />
        <Faq />
        <Gallery />
        <Footer sectionsRef={{ about: aboutRef, getInTouch: getInTouchRef, memory: memoryRef }} />
      </div>
    </>
  );
}

function ReachUsPage() {
  return (
    <>
      {/* SEO for /reach-us */}
      <Helmet>
        <title>Contact gupsy – Reach Our Team</title>
        <meta
          name="description"
          content="Have questions about gupsy, partnerships, or support? Reach out to the gupsy team through our contact page."
        />
        <link rel="canonical" href="https://www.gupsy.neomonkstech.com/reach-us" />
      </Helmet>

      <ReachUs />
    </>
  );
}

function NotFoundPage() {
  return (
    <>
      {/* 404 pages should generally NOT be indexed */}
      <Helmet>
        <title>Page Not Found – gupsy</title>
        <meta
          name="robots"
          content="noindex, nofollow"
        />
      </Helmet>

      <NotFound />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        {/* <Layout> */}
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/reach-us" element={<ReachUsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        {/* </Layout> */}
      </Router>
    </HelmetProvider>
  );
}

export default App;
